import React, { useMemo } from 'react'
import {
  EnterpriseMatchingStatus,
  EnterpriseMatchingStatusValue,
} from '../../enums/EnterpriseMatchingStatus'
import LoadingSpinner from '../loading/loading_spinner'

interface Props {
  matchingStatus: EnterpriseMatchingStatusValue
  isSubmitting: boolean
  isCheckingStatus: boolean
  onClick: () => void
  onChatClick?: () => void
}

export const MatchingRequestSection: React.FC<Props> = ({
  matchingStatus,
  isSubmitting,
  isCheckingStatus,
  onClick,
  onChatClick,
}) => {
  // ボタンのスタイルを取得
  const buttonClassName: string = useMemo(() => {
    const baseClass =
      'w-full px-4 py-3 rounded text-sm font-bold flex items-center justify-center gap-2 transition-colors'

    switch (matchingStatus) {
      case EnterpriseMatchingStatus.FORBIDDEN:
        return `${baseClass} bg-main-lightgray text-main-darkgray cursor-not-allowed opacity-50`
      case EnterpriseMatchingStatus.PENDING:
        return `${baseClass} bg-main-orange text-main-black cursor-not-allowed`
      case EnterpriseMatchingStatus.ACCEPTED:
        return `${baseClass} bg-main-lightgreen text-main-darkgray cursor-not-allowed opacity-50`
      case EnterpriseMatchingStatus.REJECTED:
        return `${baseClass} bg-main-pink text-main-black cursor-not-allowed opacity-50`
      case EnterpriseMatchingStatus.NONE:
        return `${baseClass} bg-main-green text-main-white hover:bg-main-lightgreen`
    }
  }, [matchingStatus])

  // アイコンを取得
  const icon: string = useMemo(() => {
    switch (matchingStatus) {
      case EnterpriseMatchingStatus.ACCEPTED:
        return 'check_circle'
      case EnterpriseMatchingStatus.PENDING:
        return 'schedule'
      case EnterpriseMatchingStatus.REJECTED:
        return 'cancel'
      case EnterpriseMatchingStatus.FORBIDDEN:
        return 'person'
      case EnterpriseMatchingStatus.NONE:
        return 'handshake'
    }
  }, [matchingStatus])

  const enableRequest = useMemo(() => {
    return matchingStatus === EnterpriseMatchingStatus.NONE
  }, [matchingStatus])

  return (
    <div className="mb-8 border border-main-lightgray rounded p-4">
      <h3 className="text-lg font-bold mb-4">アクション</h3>
      <div className="space-y-3">
        {isCheckingStatus ? (
          <>
            <LoadingSpinner />
          </>
        ) : (
          <>
            <button
              className={buttonClassName}
              disabled={!enableRequest || isSubmitting || isCheckingStatus}
              onClick={onClick}
              title={
                matchingStatus === EnterpriseMatchingStatus.NONE
                  ? 'クリックしてコメントを入力'
                  : ''
              }
            >
              <span className="material-icons !text-base align-middle">
                {icon}
              </span>
              {isSubmitting ? '送信中...' : 
               matchingStatus === EnterpriseMatchingStatus.PENDING ? 'マッチングリクエスト申請中です' : 
               'マッチリクエストを送る'}
            </button>

            {/* ステータスメッセージ */}
            {matchingStatus === EnterpriseMatchingStatus.ACCEPTED && (
              <p className="text-xs text-main-black text-center">
                マッチリクエストを送信済みです
              </p>
            )}
            {matchingStatus === EnterpriseMatchingStatus.FORBIDDEN && (
              <p className="text-xs text-main-black text-center">
                マッチリクエストを送信できません
              </p>
            )}

            {/* マッチング済みの場合のチャットボタン */}
            {matchingStatus === EnterpriseMatchingStatus.ACCEPTED &&
              onChatClick && (
                <>
                  <button
                    onClick={onChatClick}
                    className="w-full bg-main-white text-main-black border border-main-lightgray px-4 py-3 rounded text-sm font-bold hover:bg-main-lightgray transition-colors flex items-center justify-center gap-2"
                  >
                    <span className="material-icons !text-base align-middle">
                      chat_bubble_outline
                    </span>
                    メッセージを送る
                  </button>
                  <p className="text-xs text-main-green text-center">
                    マッチングが成立しています
                  </p>
                </>
              )}
          </>
        )}
      </div>
    </div>
  )
}
